import useApi from "../../api/useApi";

const useSpotClusterService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, spotId) => {
    return api(
      'get',
      'user/spot_cluster/' + spotId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotClusterService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, spotId, data) => {
    return api(
      'post',
      'user/spot_cluster/' + spotId + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotClusterService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, spotId, data) => {
    return api(
      'post',
      'user/spot_cluster/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotClusterService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'user/spot_cluster/' + id + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotClusterService::userDelete: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    objectType:'spot_cluster',
    userShow,
    userUpdate,
    userStore,
    userDelete,
  }
}
export default useSpotClusterService
